// Preserves `.message` from error-like values (e.g. AWS Amplify auth rejections) that aren't real Error instances.
const hasStringMessage = (e: unknown): e is { message: string } =>
  typeof e === 'object' && e !== null && typeof (e as { message?: unknown }).message === 'string';

const ensureError = (e: unknown): Error => {
  if (e instanceof Error) return e;
  if (hasStringMessage(e)) return new Error(e.message);
  return new Error(String(e));
};

export default ensureError;
